export default class GoogleStaticMaps {
    constructor() {
        this.map = "https://maps.googleapis.com/maps/api/staticmap";
    }
    load(key, element, lat, lng, zoom) {
        this.element = element;
        this.markers = [];
        this.parameters = [];
        this.parameters.push("key=" + key);
        this.parameters.push("size=1600x450");
        this.parameters.push("center=" + lat + "," + lng);
        this.parameters.push("zoom=" + zoom);
        return new Promise((resolve, reject) => {
            resolve(this);
        });
    }
    render() {
        let parameters = this.parameters.concat(this.markers);
        let query = parameters.join("&");
        let img = document.createElement("img");
        img.src = this.map + "?" + query;
        this.element.empty();
        this.element.append(img);
    }
    addMarker(lat, lng, label, info, icon, iconX, iconY) {
        let marker = [];
        if (!String.isNullOrWhitespace(label))
            marker.push("label:" + encodeURIComponent(label));
        if (icon != null)
            marker.push("icon:" + encodeURIComponent(icon));
        if (iconX != null && iconY != null)
            marker.push("anchor:" + String.format("({0},{1})", iconX.toString(), iconY.toString()));
        marker.push(lat + "," + lng);
        this.markers.push("marker=" + marker.join("|"));
    }
    removeMarker(index) {
    }
}
